module.exports = __webpack_public_path__ + "static/media/medicine.4f2ee7cc.jpg";